export const STORAGE_TOKEN_NS = 'securecore_auth_';
